import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import numeral from 'numeral';
import { orderBy } from 'lodash';
import { StatisticsTableField } from '../index';
import StatisticsTableRow from '../StatisticsTableRow';
import StatusPopupInfo from '../StatusPopupInfo';
import { getUtlParams, isMaster } from '../statisticsHelpers';
import { FMessage } from '../../../hoc/IntlComponents';
import { array, bool } from 'prop-types';
import {
  isString,
  getToFixedParams,
  _toFixed,
  getStringOrSingleArrayValue,
  LocalStorage,
  currencyToSign,
} from '../../../utils/utils';
import { STATIC_PATH } from '../../../config';

import { StatisticsConversionsTableView } from '../index';
import { UncontrolledTooltip } from 'reactstrap';
import Icon from '../../Icon/Icon';
import EditingModal from '../../../modals/EditingModal/EditingModal';
import ActionModal from '../../../modals/ActionModal/ActionModal';

const HIDDEN_COLUMNS_STORAGE_KEY = 'statistics_table_hidden_columns';

class StatisticsConversionsTable extends Component {
  static propTypes = {
    config: array.isRequired,
    stats: array.isRequired,
    hasTableEditingModalOpen: bool,
  };

  static defaultProps = {
    stats: [],
    config: [],
  };

  constructor(props) {
    super(props);
    const { tab } = props;

    const savedHiddenColumns = this.getSavedHiddenColumns(tab);

    this.state = {
      sort: {
        field: 201, // Click Date
        order: -1,
        inverse: false,
      },
      stats: this.removeEmptyStats(props.stats, props.currency),
      config: props.config,
      hiddenColumns: savedHiddenColumns,
      pendingHiddenColumns: savedHiddenColumns,
    };
  }

  UNSAFE_componentWillReceiveProps({ stats, currency }) {
    const filteredStats = this.removeEmptyStats(stats, currency);
    if (!filteredStats.length) {
      this.props.setPagesCount();
    }
    this.setState(() => ({
      stats: filteredStats,
    }));
  }

  /**
   * Remove null values
   *
   * @param {array} stats Statistics
   * @param {number} currency Currency
   *
   * @return {array} Filtered statistics
   */
  removeEmptyStats = (stats, currency) => {
    const statistics = [];

    for (let i = 0, len = stats.length; i < len; i++) {
      let row = stats[i];

      if (!row || typeof row !== 'object' || !Array.isArray(Object.values(row)[0])) {
        continue;
      }

      let firstCell = Object.values(row)[0][currency];

      if (firstCell === null) {
        continue;
      }

      statistics.push(row);
    }

    return statistics;
  };

  /**
   * Sort statistics
   *
   * @param {string} field Sort field
   * @param {boolean} inverse Inverse sort
   * @param {object} e Click event
   */
  handleSort = (field, inverse, e) => {
    e.preventDefault();

    const { sort } = this.state;
    let order = field === sort.field ? sort.order * -1 : 1;

    this.setState((prevState) => ({
      ...prevState,
      sort: {
        field,
        order,
        inverse,
      },
    }));
  };

  getCountryImg = (id) => <img src={`${STATIC_PATH}/flags/4x3/${id}.svg`} alt={id} />;

  /**
   * Format value by type
   *
   * @param {any} value
   * @param {string} type
   * @return {any} Formatted value
   */
  getFormattedValue = (value, type, statId, rowKey) => {
    const { countries, dict, offers, flows, config, filters, isMember, currency } = this.props;

    const tz = filters.timeZone;
    const { numFormat, strFormat } = getToFixedParams(config, statId);
    switch (type) {
      case 'int':
        return numeral(value).format('0,0');

      case 'float':
        return <span className="sum">{numeral(_toFixed(value, numFormat)).format(strFormat)}</span>;

      case 'money':
        const currencyString = currency === 0 ? 'rub' : currency === 1 ? 'usd' : 'eur';
        return (
          <span className="sum">
            {value % 1 === 0 ? value : numeral(_toFixed(value, numFormat)).format(strFormat)}&nbsp;
            {currencyToSign(currencyString)}
          </span>
        );

      case 'string':
        return value.toString();

      case 'stream_id':
        let stream;
        if (dict['flows'] !== undefined) {
          stream = dict['flows'].find(({ id }) => id === value);
        }
        if (!stream && flows) {
          stream = flows.find(({ id }) => id === value);
        }
        return stream && isString(stream.title) ? (
          !isMember ? (
            <Link to={`/tools/flows/${value}`}>{stream.title}</Link>
          ) : (
            stream.title
          )
        ) : (
          value
        );

      case 'date':
        return (
          <Fragment>
            <Moment unix format="DD.MM.YYYY" tz={tz}>
              {value}
            </Moment>{' '}
            <Moment unix format="HH:mm" tz={tz} className="gray">
              {value}
            </Moment>
          </Fragment>
        );
      case 'subacc':
        return (
          <Fragment>
            <span id={value} title={value}>
              {value && value.length > 40 ? value.substr(0, 5) : value}
              {value && value.length > 40 ? '...' + value.substr(value.length - 5) : ''}
            </span>
          </Fragment>
        );

      case 'offer_pixel':
        let offer, pixel;

        if (Array.isArray(value)) {
          const [offerId, pixelId] = value;

          if (dict['offers'] !== undefined) {
            offer = dict['offers'].find(({ id }) => id === offerId);
          }
          if (!offer && offers) {
            offer = offers.find(({ id }) => id === offerId);
          }
          if (dict['pixels'] !== undefined) {
            pixel = dict['pixels'].find(({ id }) => id === pixelId);
          }
          if (!pixel && offers && offers.pixels) {
            pixel = offers.pixels.find(({ id }) => id === pixelId);
          }

          return (
            <ul className="offer-goal list-unstyled no-margin">
              <li>
                {offer && isString(offer.title) ? (
                  !isMember ? (
                    <Link to={`/offers/${offer.id}`} target="_blank">
                      {offer.title}
                    </Link>
                  ) : (
                    offer.title
                  )
                ) : (
                  offerId
                )}
              </li>

              {pixel && isString(pixel.title) ? (
                <li>
                  <span className="goal">{pixel.title}</span>
                </li>
              ) : (
                pixelId
              )}
            </ul>
          );
        }

        return value;

      case 'geo_ip_referrer_info':
        let country;

        if (Array.isArray(value)) {
          const [countryId, ip, referrer, city] = value;
          country = countries.find((country) => country.id === countryId);
          return (
            <ul className="ref-info list-unstyled no-margin">
              <li>
                <span className="country">
                  {country ? (
                    <Fragment>
                      {this.getCountryImg(country.id.toLowerCase())}
                      <span>{country.title + (city ? ', ' + city : '')}</span>
                    </Fragment>
                  ) : (
                    'N/A'
                  )}
                </span>
              </li>

              {ip && (
                <li>
                  <span className="ip">{ip}</span>
                </li>
              )}

              {referrer && (
                <li>
                  <a className="referrer" href={referrer} target="_blank" title={referrer}>
                    {referrer.substr(0, 40)}
                  </a>
                </li>
              )}
            </ul>
          );
        }

        return value;

      case 'status_info': {
        const statuses = [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }, { id: 10 }]; //Temporary
        if (Array.isArray(value)) {
          const [statusId, info, popupInfo, extraParams, pixelId] = value;
          const status = statuses.find(({ id }) => id === parseInt(statusId, 10));
          return (
            <ul className="status-info list-unstyled no-margin">
              <li>
                <span className={`status status-${statusId}`}>
                  {status ? (
                    <span
                      className={`tooltip-status-info`}
                      id={`status-info-${rowKey}-${statusId}-${statId}`}
                    >
                      {/* Пустой массив приходит если никакой инфы нет, тогда попап выводить не надо */}
                      {/* Обьект приходит если есть инфа, тогда нужно выводить попап */}
                      {!Array.isArray(popupInfo) && (
                        <StatusPopupInfo
                          info={popupInfo}
                          rowKey={rowKey}
                          statId={statId}
                          statusId={statusId}
                        />
                      )}
                      <FMessage id={`statistics.table.conversions.status-${statusId}`} />
                    </span>
                  ) : (
                    statusId
                  )}
                </span>
              </li>
              {/* {info && (
                <li>
                  <span className="info">{info}</span>
                </li>
              )} */}
              {extraParams && (
                <li>
                  {extraParams.isSelf && (
                    <>
                      <UncontrolledTooltip target={`pam-icon-${rowKey}`}>
                        <FMessage id="statistics.table.conversions.tooltip.pam" />
                      </UncontrolledTooltip>
                      <Icon
                        className="pam-tooltip-icon gray"
                        id={`pam-icon-${rowKey}`}
                        type="help-question"
                      />
                      <span className="gray">
                        <FMessage id="statistics.table.conversions.status.pam" />
                      </span>
                    </>
                  )}
                  {extraParams.isTrash && (
                    <span className="gray ml-2">
                      <FMessage id="statistics.table.conversions.status.trash" />
                    </span>
                  )}
                </li>
              )}
              {dict.pixels
                ?.find((p) => p.id === pixelId)
                ?.title?.match(/Подтверждение отмены|Confirmed decline/) ? (
                <li>
                  <span className="gray">
                    <FMessage id="statistics.table.conversions.status.decline" />
                  </span>
                </li>
              ) : null}
            </ul>
          );
        }

        return value;
      }

      default:
        return value;
    }
  };

  normalizeData = (stat, key) => {
    const { currency, config } = this.props;
    const { hiddenColumns } = this.state;

    return config
      .filter((cfg) => !hiddenColumns.includes(cfg.id))
      .map(({ id, type }) => {
        if (type === 'status_info') {
          const [value] = stat[id][currency];
        }
        if (stat[id]) {
          return this.getFormattedValue(stat[id][currency], type, id, key);
        }
      });
  };

  makeFields = () => {
    const { currency, config } = this.props;
    const { hiddenColumns } = this.state;

    return config
      .filter((cfg) => !hiddenColumns.includes(cfg.id))
      .map((cfg) => ({
        id: cfg.id,
        title: cfg.title || '',
        is_sortable: cfg.sortable || false,
        type: cfg.type,
        inverse: cfg.type === 'ratio' || false,
        label: cfg.label || '',
        postfix: cfg.postfix[currency],
      }));
  };

  getOrderedStats = () => {
    const { sort, stats } = this.state;
    const { currency } = this.props;
    const direction = sort.inverse ? sort.order * -1 : sort.order * 1;

    if (stats.length > 0 && stats[0][sort.field] !== undefined) {
      return orderBy(stats, `${sort.field}[${currency}]`, direction > 0 ? 'asc' : 'desc');
    }

    return stats;
  };

  getStorageKey = (tab = null) => {
    const currentTab = tab || this.props.tab;
    if (!currentTab) {
      return HIDDEN_COLUMNS_STORAGE_KEY;
    }
    return `${HIDDEN_COLUMNS_STORAGE_KEY}_${currentTab}`;
  };

  getSavedHiddenColumns = (tab = null) => {
    try {
      const storageKey = this.getStorageKey(tab);
      const saved = LocalStorage.get(storageKey);
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error('Error loading hidden columns from LocalStorage:', error);
      return [];
    }
  };

  saveHiddenColumnsToStorage = (hiddenColumns, tab = null) => {
    try {
      const storageKey = this.getStorageKey(tab);
      LocalStorage.set(storageKey, JSON.stringify(hiddenColumns));
    } catch (error) {
      console.error('Error saving hidden columns to LocalStorage:', error);
    }
  };

  mergeConfigWithStorage = (config) => {
    return config;
  };

  getAllGroups = () => {
    const { config, customStrings = {} } = this.props;
    const { group: customTitles } = customStrings;

    const groups = new Set();

    config.forEach((column) => {
      if (column.isRendering !== false) {
        const groupId = column.group || '__EMPTY__';
        let groupTitle = groupId;

        if (customTitles && customTitles[groupId]) {
          groupTitle = customTitles[groupId];
        }

        groups.add(groupTitle);
      }
    });

    return Array.from(groups);
  };

  togglePendingColumnVisibility = (columnId) => {
    this.setState((prevState) => {
      const pendingHiddenColumns = [...prevState.pendingHiddenColumns];
      const columnIndex = pendingHiddenColumns.indexOf(columnId);

      if (columnIndex > -1) {
        pendingHiddenColumns.splice(columnIndex, 1);
      } else {
        pendingHiddenColumns.push(columnId);
      }

      return { pendingHiddenColumns };
    });
  };

  applyColumnChanges = () => {
    const { pendingHiddenColumns } = this.state;
    const { tab, handleHasEditingModalToggle } = this.props;

    this.setState(
      {
        hiddenColumns: [...pendingHiddenColumns],
      },
      () => {
        this.saveHiddenColumnsToStorage(pendingHiddenColumns, tab);
        handleHasEditingModalToggle();
      },
    );
  };

  handleCancelChanges = () => {
    this.setState({ pendingHiddenColumns: [...this.state.hiddenColumns] });
    this.props.handleHasEditingModalToggle();
  };

  isColumnHidden = (columnId) => {
    return this.state.hiddenColumns.includes(columnId);
  };

  isPendingColumnHidden = (columnId) => {
    return this.state.pendingHiddenColumns?.includes(columnId);
  };

  renderTableFields = () => {
    const fields = this.makeFields();
    const { sort } = this.state;

    return fields.map((field) => (
      <StatisticsTableField
        onSort={this.handleSort}
        {...field}
        key={field.id}
        sorted={sort.field === field.id}
        order={sort.order}
        isInConversionsTable
      />
    ));
  };

  renderStats = () => {
    const stats = this.splitStats(this.getOrderedStats());
    const { page, config, currency } = this.props;

    return stats[page].map((stat, key) => {
      const getStatus = (_) => {
        return config
          .map(({ id, type }) => {
            if (type === 'status_info') {
              const [value] = stat[id][currency];
              return value;
            }
          })
          .filter((value) => (value ? value : false))[0];
      };

      const status = getStatus() ? getStatus() : 0;

      const getisTrash = (_) => {
        const item = config
          .map(({ id, type }) => {
            if (type === 'status_info') {
              const [, , , extraParams] = stat[id][currency];
              return extraParams;
            }
          })
          .filter((extraParams) => (extraParams ? extraParams : false))[0];
        return item ? item.isTrash : false;
      };

      const isTrash = getisTrash();

      return (
        <StatisticsTableRow
          className="text-right"
          status={status}
          isTrash={isTrash}
          key={key}
          stats={this.normalizeData(stat, key)}
        />
      );
    });
  };

  setGroups = () => {
    const { config, stats } = this.props;

    const groups = config.reduce((result, field) => {
      if (field.unit) {
        if (result[field.unit]) {
          return { ...result, [field.unit]: [...result[field.unit], field.id] };
        } else {
          return { ...result, [field.unit]: [field.id] };
        }
      } else {
        return { ...result, [field.id]: field.id };
      }
    }, {});

    this.setState(() => ({ groups }));
  };

  splitStats = (stats = []) => {
    const chunked = [];
    const { limit, setPagesCount } = this.props;

    for (let i = 0, len = stats.length; i < len; i += limit) {
      chunked.push(stats.slice(i, i + limit));
    }
    setPagesCount(chunked.length);
    return chunked;
  };

  renderEmptyData = () => {
    const { config, loading, isMounted } = this.props;
    return (
      <tr>
        <td className="empty-stats" colSpan={config.length}>
          {loading ? (
            <FMessage id="statistics.table.loading" />
          ) : !isMounted ? null : (
            <FMessage id="statistics.table.no-data" />
          )}
        </td>
      </tr>
    );
  };

  renderColumnControls = () => {
    const { config } = this.props;

    const {
      customStrings = {},
      hasTableEditingModalOpen,
      hasActionModalOpen,
      handleHasActionModalToggle,
      isMember,
      isSharing,
      setSharingState,
      showAlert,
      requestParams,
      theme,
      onRefresh,
      handleHasEditingModalToggle,
      handleHasExportModalToggle,
    } = this.props;
    const { group: customTitles } = customStrings;
    const allGroups = this.getAllGroups();

    return (
      <>
        <EditingModal
          config={config}
          customTitles={customTitles}
          hasTableEditingModalOpen={hasTableEditingModalOpen}
          allGroups={allGroups}
          isPendingColumnHidden={this.isPendingColumnHidden}
          togglePendingColumnVisibility={this.togglePendingColumnVisibility}
          handleCancelChanges={this.handleCancelChanges}
          applyColumnChanges={this.applyColumnChanges}
        />

        <ActionModal
          isOpen={hasActionModalOpen}
          isMember={isMember}
          isSharing={isSharing}
          setSharingState={setSharingState}
          showAlert={showAlert}
          requestParams={requestParams}
          theme={theme}
          handleRefresh={onRefresh}
          handleHasEditingModalToggle={handleHasEditingModalToggle}
          handleHasExportModalToggle={handleHasExportModalToggle}
          handleClose={handleHasActionModalToggle}
        />
      </>
    );
  };

  render() {
    const { stats } = this.state;

    const {
      page,
      config,
      currency,
      countries,
      dict,
      offers,
      flows,
      filters,
      isMember,
      currencies,
    } = this.props;

    return (
      <>
        <StatisticsConversionsTableView
          stats={stats}
          page={page}
          config={config}
          currency={currency}
          currencies={currencies}
          renderTableFields={this.renderTableFields}
          renderStats={this.renderStats}
          renderEmptyData={this.renderEmptyData}
          makeFields={this.makeFields}
          normalizeData={this.normalizeData}
          splitStats={this.splitStats}
          getOrderedStats={this.getOrderedStats}
          countries={countries}
          dict={dict}
          offers={offers}
          flows={flows}
          filters={filters}
          isMember={isMember}
        />

        {this.renderColumnControls()}
      </>
    );
  }
}

const mapStateToProps = ({ app, webmaster, statistics, streams, slaves }) => {
  const {
    parsedQuery: { timeZone: tz },
  } = getUtlParams();
  const timeZone = tz
    ? tz
    : statistics.filters.timeZone
    ? getStringOrSingleArrayValue(statistics.filters.timeZone)
    : webmaster.profile.timezone;
  const master = isMaster();
  return {
    theme: webmaster.profile.theme,
    countries: app.globalSettings.countries,
    sites: !master ? webmaster.sites : slaves.slaveSites,
    dict: !master ? statistics.dict : slaves.dict,
    offers: !master ? webmaster.offers : slaves.offers,
    flows: !master ? streams.streams : slaves.streams.streams,
    filters: { ...statistics.filters, timeZone },
    timeZones: app.globalSettings.timezones,
  };
};

export default connect(mapStateToProps)(StatisticsConversionsTable);
